module.exports = __webpack_public_path__ + "static/media/17-10.13935c4a.mp3";